import React from 'react';
import CONSTANTS from '../../constants';
import { Button } from "../Forms/Forms";


const ConfirmationDialog = (props) => {
	return (
		<div className="dialog-container dialog-confirmation">
			<p className="dialog-content" dangerouslySetInnerHTML={{ __html: (CONSTANTS.LABELS.header_modification_popin_label) }}></p>
			<Button Type="border" onClick={(e) => props.isConfirmedDialog(true)}>{CONSTANTS.LABELS.header_modification_popin_confirm}</Button>
			<Button Type="border" onClick={(e) => props.isConfirmedDialog(false)}>{CONSTANTS.LABELS.header_modification_popin_cancel} </Button>
		</div>
	)
}


export default ConfirmationDialog;
